import { render, staticRenderFns } from "./FormularioConfiguracionPacientes.vue?vue&type=template&id=667c2513&scoped=true"
import script from "./FormularioConfiguracionPacientes.vue?vue&type=script&lang=js"
export * from "./FormularioConfiguracionPacientes.vue?vue&type=script&lang=js"
import style0 from "./FormularioConfiguracionPacientes.vue?vue&type=style&index=0&id=667c2513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c2513",
  null
  
)

export default component.exports